import { Datepicker } from 'vanillajs-datepicker'
import sk from 'vanillajs-datepicker/locales/sk';

document.onreadystatechange = () => {

    if ( document.readyState === 'complete' ) {

        const datepickerElements = document.querySelectorAll('.js-datepicker')
        const locale = document.querySelector('html').getAttribute('lang')

        if ( datepickerElements ) {

            Object.assign(Datepicker.locales,  sk)

            datepickerElements.forEach( (element, key) => {
                let datepicker = new Datepicker(element, {
                    // format: 'yyyy-mm-dd',
                    format: 'dd.mm.yyyy',
                    language: locale
                })

                if ( window.innerWidth < 1199 ) {
                    element.addEventListener('changeDate', function (event) {
                        console.log('here')
                        this.closest('.c-booking').classList.add('active')
                    })
                }
            })
        }
    }
}


